/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Link from '@atlaskit/link';

const messages = defineMessages({
	userProfileValue: {
		id: 'organization.audit.log.side-panel.tab-panels.details.sub-section.user-profile.row-value',
		defaultMessage: 'Go to profile',
		description: 'Value for the user profile link in audit log actor section',
	},
});

interface UserProfileLinkProps {
	profileUrl: string;
}

export const UserProfileLink = ({ profileUrl }: UserProfileLinkProps): JSX.Element => {
	return (
		<Link href={profileUrl} target="_blank">
			<FormattedMessage {...messages.userProfileValue} />
		</Link>
	);
};
